import { useQuery } from 'react-query'
import { api } from '../../../../services/api'
import { useUser } from '../../../../hooks/useUser'

export function usePedidos(filtros = {}) {
  const { codigo_usuario } = useUser() // Obtendo o código do usuário

  const buildQueryParams = (filtros) => {
    const params = new URLSearchParams()

    // Adicionar o código do usuário obrigatório
    params.append('codigo_usuario', codigo_usuario)

    if (filtros.numeroPedido) params.append('codigo', filtros.numeroPedido)
    if (filtros.dataInicio) params.append('data_inicio', formatDateToAPI(filtros.dataInicio))
    if (filtros.dataFim) params.append('data_fim', formatDateToAPI(filtros.dataFim))
    if (filtros.passoAtual) params.append('status', filtros.passoAtual)
    if (filtros.proximoPasso) params.append('proximo_passo', filtros.proximoPasso)

    // Adicionar filtros de tipo de gravação se existirem
    if (filtros.tiposGravacao && filtros.tiposGravacao.length > 0) {
      params.append('tipos_gravacao', filtros.tiposGravacao.join(','))
    }

    return params.toString()
  }

  const formatDateToAPI = (dateString) => {
    if (!dateString) return ''
    return dateString
  }

  const fetchPedidos = async () => {
    const queryString = buildQueryParams(filtros)
    // Garantir que a queryString sempre terá pelo menos o codigo_usuario
    const url = `/site/v2/tercerizado/listar-status-tercerizado?${queryString}`

    const response = await api.get(url)

    return response.data.map(formatPedido)
  }

  const formatPedido = (pedido) => {
    return {
      data: formatarDataHora(pedido.data_entrada),
      pedido: pedido.pedido?.toString() || '',
      dataAprovacao: formatarDataHora(pedido.data_aprovacao),
      codigoProduto: (pedido.codigo_produto || 0).toString(),
      produto: pedido.nome_produto || '',
      cor: pedido.cor_produto || '',
      gravacao: pedido.gravacao || '',
      recebimento: formatarDataHora(pedido.data_recebimento || pedido.data_aprovacao),
      statusAtual: pedido.status_atual || '',
      proximaEtapa: pedido.proxima_etapa || '',
      estimativaPrazo: `${pedido.prazo || '10'} dias úteis`,
      limitePrazo: formatarDataSimples(pedido.limite_producao),
      quantidade:
        typeof pedido.quantidade === 'number' ? pedido.quantidade.toLocaleString('pt-BR') : (pedido.quantidade || '0').toLocaleString('pt-BR'),
    }
  }

  return useQuery(['@pedidos-aprovados', filtros], fetchPedidos, {
    staleTime: 1000 * 60 * 5, // 5 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    keepPreviousData: true,
  })
}

function formatarDataHora(dataString) {
  if (!dataString) return ''

  try {
    const [dataParte, horaParte] = dataString.split(' ')
    if (!dataParte) return dataString

    const [ano, mes, dia] = dataParte.split('-')
    const hora = horaParte ? horaParte.split('.')[0] : ''

    return `${dia}/${mes}/${ano} ${hora}`
  } catch (error) {
    console.error('Erro ao formatar data:', error)
    return dataString
  }
}

function formatarDataSimples(dataString) {
  if (!dataString) return ''

  try {
    const [dataParte] = dataString.split(' ')
    if (!dataParte) return dataString

    const [ano, mes, dia] = dataParte.split('-')
    return `${dia}/${mes}/${ano}`
  } catch (error) {
    console.error('Erro ao formatar data:', error)
    return dataString
  }
}
